var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"date"},[_c('div',{staticClass:"bubble"},[_vm._v(" "+_vm._s(_vm.createdAt)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }